import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="onboarding--intents-selection"
export default class extends Controller {
  static targets = ["submitButton", "checkbox"]

  connect() {
    this.toggleSubmitButton()
  }

  toggleSubmitButton() {
    const anyChecked = this.checkboxTargets.some((cb) => cb.checked)

    if (anyChecked) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("disabled")
    } else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("disabled")
    }
  }
}
